import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { assets } from '../config/assets'
import SubscriptionCarousel from '../components/SubscriptionCarousel'
import Footer from '../components/Footer'
import AboutUsSection from '../components/home/AboutUsSection'
import FaqSection from '../components/home/FaqSection'
import { easeInOutScroll } from '../utils/scroll'

export default function HomePage() {
  const { t } = useTranslation()
  const aboutRef = useRef(null)

  const scrollToAbout = () => {
    const target = aboutRef.current
    if (!target) return
    const top = target.getBoundingClientRect().top + window.scrollY
    easeInOutScroll(window.document.scrollingElement || window, top, 800)
  }

  return (
    <div>
      {/* Section 1: Logo + Carousel */}
      <section
        className="px-4 relative min-h-[100dvh] flex flex-col justify-center overflow-hidden"
        aria-label={t('home.sectionHero')}
      >
        <div className="w-full min-h-0 flex flex-col items-center md:justify-evenly gap-3 pt-5 md:pt-[2vh] pb-20 overflow-hidden">
          <h1 className="font-climate text-brand-gold text-[clamp(1.5rem,7vw,8vh)] md:text-[clamp(2rem,8vw,9vh)] leading-none text-center drop-shadow-2xl select-none px-2 inline-block scale-x-[0.75] tracking-[-0.02em]">
            {t('home.title')}
          </h1>
          <div className="flex-1 md:flex-none flex items-center justify-center w-full min-h-0">
            <SubscriptionCarousel />
          </div>
        </div>

        <button
          type="button"
          onClick={scrollToAbout}
          aria-label={t('home.whatIsIt')}
          className="absolute left-1/2 -translate-x-1/2 bottom-5 z-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold flex flex-col items-center gap-1"
        >
          <span className="text-brand-gold font-climate text-sm tracking-widest uppercase drop-shadow-lg">
            {t('home.whatIsIt')}
          </span>
          <img src={assets.arrowDown} alt="" className="w-24 h-auto drop-shadow-2xl" />
        </button>
      </section>

      {/* Section 2: About us */}
      <section
        id="about"
        ref={aboutRef}
        className="px-4 py-12 md:py-20 bg-section-cream relative"
        aria-label={t('home.sectionAbout')}
      >
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label={t('home.sectionHero')}
          className="absolute left-1/2 -translate-x-1/2 top-5 z-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold flex flex-col items-center gap-1"
        >
          <span className="text-brand-gold font-climate text-sm tracking-widest uppercase drop-shadow-lg">
            {t('home.sectionHero')}
          </span>
          <img src={assets.arrowUp} alt="" className="w-24 h-auto drop-shadow-2xl" />
        </button>
        <AboutUsSection />
      </section>

      {/* Section 3: FAQ */}
      <section
        id="faq"
        className="px-4 py-12 md:py-20 bg-section-cream"
        aria-label={t('home.sectionFaq')}
      >
        <FaqSection />
      </section>

      <Footer />
    </div>
  )
}
